import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  position: 'relative',
  background: '#FFF',
  borderBottom: 0,
  overflowX: 'auto',
  overflowY: 'auto',
});
